var _title, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCloud = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "112px",
    viewBox: "0 0 78 112",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.643965 0 0 0 0 0.394698 0 0 0 0 0.315982 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.847059 0 0 0 0 0.835294 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Template-Creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2-Upload-document",
    transform: "translate(-284.000000, -217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(284.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L68,0 L68,88 L0,88 L0,0 Z",
    id: "Rectangle-Copy-4",
    fill: "#D2866E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.500000, 17.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#EED8D5",
    points: "0 0 25 0 25 6 0 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    fill: "#EED8D5",
    points: "0 12 32 12 32 18 0 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    fill: "#EED8D5",
    points: "0 24 40 24 40 30 0 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    fill: "#EED8D5",
    points: "0 36 18 36 18 42 0 42"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(42.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "up-arrow"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 45.473684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1800192,0 L1.81998076,0 C1.07648561,0 0.473684211,0.636273279 0.473684211,1.42105263 C0.473684211,2.20583198 1.07648561,2.84210526 1.81998076,2.84210526 L16.1800192,2.84210526 C16.9235144,2.84210526 17.5263158,2.20583198 17.5263158,1.42105263 C17.5263158,0.636273279 16.9236862,0 16.1800192,0 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1800192,4.73684211 L1.81998076,4.73684211 C1.07648561,4.73684211 0.473684211,5.37311538 0.473684211,6.15789474 C0.473684211,6.94267409 1.07648561,7.57894737 1.81998076,7.57894737 L16.1800192,7.57894737 C16.9235144,7.57894737 17.5263158,6.94267409 17.5263158,6.15789474 C17.5263158,5.37311538 16.9236862,4.73684211 16.1800192,4.73684211 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1800192,10.4210526 L1.81998076,10.4210526 C1.07648561,10.4210526 0.473684211,11.0573259 0.473684211,11.8421053 C0.473684211,12.6268846 1.07648561,13.2631579 1.81998076,13.2631579 L16.1800192,13.2631579 C16.9235144,13.2631579 17.5263158,12.6268846 17.5263158,11.8421053 C17.5263158,11.0573259 16.9236862,10.4210526 16.1800192,10.4210526 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M35.5778043,17.0540632 L18.8788521,0.419716769 C18.4756144,-0.0741303678 17.7552708,-0.141916665 17.2699388,0.268224666 C17.2159383,0.313929063 17.1659751,0.364597608 17.1210588,0.419716769 L0.42210662,17.0540632 C-0.111842649,17.5576674 -0.143469134,18.4065367 0.351451708,18.9498542 C0.596893416,19.2192876 0.940074421,19.3745456 1.30108738,19.3793386 L9.21107309,19.3793386 L9.21107309,40.9322997 C9.36113067,41.8330358 10.0771005,42.5251065 10.9688664,42.6315789 L25.0312127,42.6315789 C25.7343973,42.6315789 25.9100253,41.7373476 25.9100253,40.9322997 L25.9100253,19.3793386 L34.6989917,19.3793386 C35.4270738,19.3695814 36.0094722,18.7612165 36,18.0203603 C35.9951729,17.6530133 35.842592,17.3038112 35.5778043,17.0540632 Z",
    id: "Path",
    fill: "#EED8D5",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cloud.71cc052d.svg";
export { ForwardRef as ReactComponent };